export default class ImagePreloader {
  /*
    @param images
        {object} containing URLS to images
    @param size
        {string} containing image size to return images as
  */
  constructor(images, size) {
    this.images = images;
    this.size = size;
    this.images.map(image => this._loadImage(this._getSizedImageURL(image, this.size)));
  }

  _getSizedImageURL(segment, size) {
    if (size === 'master') {
      return this.removeProtocol(segment);
    }

    const segmentMatch = segment.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (!segmentMatch) { return null; }

    const imageId = segmentMatch[0];
    const dateElements = segment.split(imageId);

    return this._removeProtocol(`${dateElements[0]}_${size}${imageId}`);
  }

  _removeProtocol(segment) {
    return segment.replace(/http(s)?:/, '');
  }

  _loadImage(path) {
    (new Image()).src = path;
  }
}
